<template>
  <k-header />
  <router-view />
  <k-footer />
  
</template>

<script>
import KHeader from "./components/KHeader.vue";
import KFooter from "./components/KFooter.vue";
require('@/assets/styles/base.css')
export default {
  components: {
    KHeader,
    KFooter,
  },
  data() {
    return {
    };
  },
  methods: {
  
  },
 
};
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

</style>
